import { render, staticRenderFns } from "./user-days.vue?vue&type=template&id=565b620f"
import script from "./user-days.vue?vue&type=script&lang=js"
export * from "./user-days.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports